import { render, staticRenderFns } from "./sampleReview.vue?vue&type=template&id=2ba20ea2&scoped=true&"
import script from "./sampleReview.vue?vue&type=script&lang=js&"
export * from "./sampleReview.vue?vue&type=script&lang=js&"
import style0 from "./sampleReview.vue?vue&type=style&index=0&id=2ba20ea2&lang=scss&scoped=true&"
import style1 from "./sampleReview.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba20ea2",
  null
  
)

export default component.exports